import { IconSearch } from '@/blocks/components/Icons/Search';
import InputAdornment from '@mui/material/InputAdornment';

export function SearchStartAdornment() {
  return (
    <InputAdornment position={'start'}>
      <IconSearch />
    </InputAdornment>
  );
}
